import { PERMISSIONS } from '../../helpers/auth';

export const PAGES = (hasRole) => [
  {
    title: 'my_devices',
    description: 'my_devices_desc',
    iconName: 'myDevices',
    buttonName: 'invoicing',
    redirectUrl: 'my-devices',
    hide: !hasRole(PERMISSIONS.VIEW_DEVICE),
  },
  {
    title: 'my_invoices',
    description: 'my_invoices_desc',
    iconName: 'myInvoices',
    buttonName: 'register',
    redirectUrl: 'invoice-view',
    hide: !hasRole(PERMISSIONS.VIEW_INVOICE_LIST),
  },
  {
    title: 'additional_functionalities',
    description: 'additional_functionalities_desc',
    iconName: 'additional_functionalities',
    redirectUrl: 'additional-functionalities',
    hide:
      !hasRole(PERMISSIONS.VIEW_CORE_INVOICE_LIST) &&
      !hasRole(PERMISSIONS.VIEW_AGREEMENT) &&
      !hasRole(PERMISSIONS.VIEW_REPORTED_FAILURES),
  },
];

export const ROUTES = [
  {
    label: 'breadcrumb_e_invoicing',
    link: '',
  },
];
